import React from 'react';

import { Dialog, DialogActions, DialogContent, DialogTitle, ThemeProvider } from '@mui/material';

import { Button } from 'new/elements/Button';
import TypographySupport from 'new/elements/Typography';
import makeFinalTheme from 'new/theme';
import { draftEventTypes } from 'new/components/flows/types/genai_rag/context/Draft/useDraftContext';

const styles = {
  dialogTitle: {
    fontSize: 17,
    fontWeight: 500,
    color: 'rgba(0, 0, 0, 0.87)',
  },
  dialogMessage: {
    fontSize: 14,
    color: 'rgba(0, 0, 0, 0.6)',
  },
};

function ConfirmationContent({
  _no,
  _yes,
  title,
  message,
  showCancelButton,
  cancelButtonLabel,
  okButtonLabel,
  okButtonTheme = 'delete',
  eventType,
  okButtonColor,
}) {
  const okColor =
    okButtonColor || (eventType === draftEventTypes.PUBLISH_CONFIRM ? 'primary' : 'error');

  return (
    <>
      <DialogTitle>
        <TypographySupport variant="span" style={styles.dialogTitle}>
          {title}
        </TypographySupport>
      </DialogTitle>
      <DialogContent>
        <TypographySupport variant="body1" style={styles.dialogMessage}>
          {message}
        </TypographySupport>
      </DialogContent>
      <DialogActions>
        {showCancelButton === true && (
          <Button
            color="info"
            variant="contained"
            data-testid="user-confirmation-cancel-button"
            onClick={_no}
          >
            {cancelButtonLabel}
          </Button>
        )}
        <Button
          color={okColor}
          variant="contained"
          data-testid="user-confirmation-ok-button"
          buttonTheme={okButtonTheme}
          onClick={_yes}
        >
          {okButtonLabel}
        </Button>
      </DialogActions>
    </>
  );
}

class UserConfirmation extends React.Component {
  constructor(props) {
    super(props);

    this._yes = this._yes.bind(this);
    this._no = this._no.bind(this);
  }

  _yes() {
    this.props.onConfirm(true);
  }

  _no() {
    this.props.onCancel(false);
  }

  render() {
    return (
      <ThemeProvider theme={makeFinalTheme()}>
        <Dialog open={true} maxWidth="sm" fullWidth>
          <ConfirmationContent {...this.props} _no={this._no} _yes={this._yes} />
        </Dialog>
      </ThemeProvider>
    );
  }
}

export const CustomUserConfirmation = ({
  title,
  message,
  cancelButtonLabel,
  okButtonLabel,
  onConfirm,
  onClose,
  yesWithChangesButtonLabel,
  onRunWithIngestion,
}) => {
  return (
    <ThemeProvider theme={makeFinalTheme()}>
      <Dialog open={true} maxWidth="sm" fullWidth>
        <DialogTitle>
          <TypographySupport variant="span" style={styles.dialogTitle}>
            {title}
          </TypographySupport>
        </DialogTitle>
        <DialogContent>
          <TypographySupport variant="body1" style={styles.dialogMessage}>
            {message}
          </TypographySupport>
        </DialogContent>
        <DialogActions>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              width: '100%',
            }}
          >
            <Button
              color="info"
              variant="contained"
              data-testid="user-confirmation-cancel-button"
              onClick={onClose}
            >
              {cancelButtonLabel}
            </Button>

            <div
              style={{
                display: 'flex',
                gap: 20,
              }}
            >
              <Button
                color="primary"
                variant="outlined"
                data-testid="user-confirmation-save-and-run-button"
                onClick={() => {
                  onConfirm(true);
                }}
              >
                {yesWithChangesButtonLabel}
              </Button>

              <Button
                color={'primary'}
                variant="contained"
                data-testid="user-confirmation-save-button"
                onClick={() => {
                  onRunWithIngestion(false);
                }}
              >
                {okButtonLabel}
              </Button>
            </div>
          </div>
        </DialogActions>
      </Dialog>
    </ThemeProvider>
  );
};

UserConfirmation.defaultProps = {
  title: 'Exit Editor',
  okButtonLabel: 'Exit Editor',
  cancelButtonLabel: 'Cancel',
  showCancelButton: true,
};

export default UserConfirmation;
